import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import { StyledTableCell, StyledTableRow } from "../../style/style";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function ViewDetails(props) {
  const handleClose = () => {
    props.setOpen(false);
  };

  return (
    <React.Fragment sx={{ width: "100%" }}>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        fullWidth={true}
        maxWidth="md"
        sx={{ width: "100%" }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Replacement Device Details
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers sx={{ width: "100%" }}>
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>
                    <b>#</b>
                  </StyledTableCell>
                  <StyledTableCell>
                    <b>Previous Info</b>
                  </StyledTableCell>
                  <StyledTableCell>
                    <b>Updated Info</b>
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell>IMEI</StyledTableCell>
                  <StyledTableCell>
                    {props.selectedDevice.old_device_imei}
                  </StyledTableCell>
                  <StyledTableCell>
                    {props.selectedDevice.new_device_imei}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell>ICCID</StyledTableCell>
                  <StyledTableCell>
                    {props.selectedDevice.old_device_iccid}
                  </StyledTableCell>
                  <StyledTableCell>
                    {props.selectedDevice.new_device_iccid}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell>Serial Number</StyledTableCell>
                  <StyledTableCell>
                    {props.selectedDevice.old_device_sn}
                  </StyledTableCell>
                  <StyledTableCell>
                    {props.selectedDevice.new_device_sn}
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        {/* <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Save changes
          </Button>
        </DialogActions> */}
      </BootstrapDialog>
    </React.Fragment>
  );
}
